import React, { useMemo, useState, useEffect, useRef } from 'react';
import { OverlayTrigger, Tooltip, Card, Col, Row } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import SelectFild from '../../components/SelectFild/SelectFild';
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import DateFild from '../../components/DateTimePicker/DateFild';
import { FaPlus, FaSyncAlt, FaEnvelopeOpenText, FaCheckCircle, FaRegDotCircle, FaRegCheckCircle } from "react-icons/fa";
import TimeFild from '../../components/DateTimePicker/TimeFild';
import DateToDayFild from '../../components/DateTimePicker/DateToDayFild';
import { postCommunicationLogDropdown, postCommunicationLogHistory, postCommunicationLogSave, postCommonMaster, getProjectDetails, getProjectFullDetails, postChangeActivityStatus, postProjectActivityCompletionData, getProjectActivityDetails, postProject, postProjectSave, postProjectList, postProductActivityList, postProductRoleList, deleteProject, postProjectDocumentSave, getProjectDocument, deleteProjectDocuments, postDocumentFileList, postEmailTemplateRenderBody, postProjectSendMail } from '../../apiservices/ApiServices';
import { FaFilePdf, FaTrashAlt, FaEye } from "react-icons/fa";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Heading,
    Bold,
    Italic,
    Underline,
    Strikethrough,
    Code,
    Subscript,
    Superscript,
    Font,
    FontFamily,
    FontSize,
    FontColor,
    FontBackgroundColor,
    Alignment,
    Link,
    List,
    TodoList,
    BlockQuote,
    Indent,
    IndentBlock,
    Table,
    TableToolbar,
    TableProperties,
    TableCellProperties,
    HorizontalLine,
    RemoveFormat,
    SpecialCharacters,
    SourceEditing,
    GeneralHtmlSupport,
    Undo
} from 'ckeditor5';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';

const Projects = () => {
    const [ids, setIds] = useState('');
    const [step, setStep] = useState(1);
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [sendEmailModal, setSendEmailModal] = useState(false);
    const [viewModal, setViewModal] = useState(false);
    const [uploadDocument, setUploadDocument] = useState(false);
    const [fullDetails, setFullDetails] = useState([]);
    const [activityDetails, setActivityDetails] = useState([]);
    const [proName, setProName] = useState('');
    const [showLogModal, setShowLogModal] = useState(false);
    const [activityStatus, setActivityStatus] = useState(false);
    const [activityList, setActivityList] = useState([]);
    const [activitysDetail, setActivitysDetail] = useState([]);
    const [commonMaster, setCommonMaster] = useState([]);
    const [projectList, setProjectList] = useState([]);
    const [editData, setEditData] = useState([]);
    const [rolesData, setRolesData] = useState({ project: null, category: [], sub_category: [], product: [] });
    const [clientPersons, setClientPersons] = useState([]);
    const [billingPersons, setBillingPersons] = useState([]);
    const [roleAssignments, setRoleAssignments] = useState({ client: {}, billing: {} });
    const [dropdownList, setDropdownList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [logHistory, setLogHistory] = useState([]);
    const [files, setFiles] = useState([]);
    const [documentList, setDocumentList] = useState([]);
    const [activityId, setActivityId] = useState('');
    const [subActivityId, setsubActivityId] = useState('');
    const [activityEmails, setActivityEmails] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [ccselectedIds, setccSelectedIds] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState([]);
    const [selectedProjDocument, setSelectedProjDocument] = useState([]);
    const [documentListData, setDocumentListData] = useState([]);
    const [emailBody, setEmailBody] = useState('');

    const postProjects = async (postData) => {
        setLoading(true);
        try {
            const res = await postProject(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.project_id,
                projectCategory: item?.project_category?.proj_category_name,
                entityName: item?.billing_entity?.org_name,
                clientName: item?.client?.org_name,
                startDate: item?.start_date,
                endDate: item?.end_date,
                managedBy: item?.project_manager,
            }));
            setData(formattedData);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdates = async () => {
        let postData = {
            length: 100
        }
        try {
            const res = await postProject(postData);
            const formattedData = res?.data?.data?.records.map(item => ({
                id: item?.project_id,
                projectCategory: item?.project_category?.proj_category_name,
                entityName: item?.billing_entity?.org_name,
                clientName: item?.client?.org_name,
                startDate: item?.start_date,
                endDate: item?.end_date,
                managedBy: item?.project_manager,
            }));
            setData(formattedData);

        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postProjectLists = async (id) => {
        setLoadings(false);
        let postData = {
            project_id: id
        }
        try {
            const res = await postProjectList(postData);
            setProjectList(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    const postProductActivityLists = async (id) => {
        setLoadings(false);
        let postData = {
            project_id: id
        }
        try {
            const res = await postProductActivityList(postData);
            setActivityList(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    const postProductRoleLists = async (id) => {
        setLoadings(true);
        let postData = { project_id: id };
        try {
            const res = await postProductRoleList(postData);
            const { roles, client_person, billing_entity_person } = res.data.data;

            // 1. Store role structures
            setRolesData({
                project: roles.project,
                category: roles.category || [],
                sub_category: roles.sub_category || [],
                product: roles.product || []
            });

            // 2. Format persons
            const formattedClient = client_person.map(p => ({
                contact_person_id: p.contact_person_id,
                name: `${p.first_name} ${p.last_name}`.trim(),
                email: p.email,
                mobile_number: p.mobile_number,
            }));
            const formattedBilling = billing_entity_person.map(p => ({
                contact_person_id: p.contact_person_id,
                name: `${p.first_name} ${p.last_name}`.trim(),
                email: p.email,
                mobile_number: p.mobile_number,
            }));
            setClientPersons(formattedClient);
            setBillingPersons(formattedBilling);

            // 3. Build role assignments from API data
            const buildAssignments = () => {
                const clientAssign = {};
                const billingAssign = {};

                // Helper to initialise empty objects for all persons (so every person appears in the state)
                const initPersons = (itemId) => {
                    if (!clientAssign[itemId]) clientAssign[itemId] = {};
                    if (!billingAssign[itemId]) billingAssign[itemId] = {};
                    formattedClient.forEach(p => {
                        if (!clientAssign[itemId][p.contact_person_id]) clientAssign[itemId][p.contact_person_id] = {};
                    });
                    formattedBilling.forEach(p => {
                        if (!billingAssign[itemId][p.contact_person_id]) billingAssign[itemId][p.contact_person_id] = {};
                    });
                };

                // Helper to apply existing assignments (set true for assigned roles)
                const applyCentric = (itemId, clientCentric, billingCentric) => {
                    initPersons(itemId);
                    clientCentric.forEach(({ contact_person_id, centri_ids }) => {
                        centri_ids.forEach(roleId => {
                            clientAssign[itemId][contact_person_id][roleId] = true;
                        });
                    });
                    billingCentric.forEach(({ contact_person_id, centri_ids }) => {
                        centri_ids.forEach(roleId => {
                            billingAssign[itemId][contact_person_id][roleId] = true;
                        });
                    });
                };

                // Process each level
                if (roles.project) {
                    applyCentric('project', roles.project.client_centric || [], roles.project.billing_entity_centric || []);
                }
                (roles.category || []).forEach(cat => {
                    applyCentric(cat.category_id, cat.client_centric || [], cat.billing_entity_centric || []);
                });
                (roles.sub_category || []).forEach(sub => {
                    applyCentric(sub.sub_category_id, sub.client_centric || [], sub.billing_entity_centric || []);
                });
                (roles.product || []).forEach(prod => {
                    applyCentric(prod.product_id, prod.client_centric || [], prod.billing_entity_centric || []);
                });

                return { client: clientAssign, billing: billingAssign };
            };

            const assignments = buildAssignments();
            setRoleAssignments(assignments);

            setLoadings(false);
        } catch (error) {
            //toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postProjects(postData);
    }, []);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        handleFiles(droppedFiles);
    };

    const handleFileSelect = (e) => {
        const selectedFiles = Array.from(e.target.files);
        handleFiles(selectedFiles);
    };

    const handleFiles = (fileList) => {
        const validFiles = fileList.filter(file =>
            file.type.startsWith('image/') || file.type === 'application/pdf'
        );

        setFiles(prev => [...prev, ...validFiles]);

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const removeFile = (index) => {
        setFiles(prev => prev.filter((_, i) => i !== index));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.classList.add('dragover');
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        e.currentTarget.classList.remove('dragover');
    };
    const fileInputRef = useRef(null);

    const columns = useMemo(
        () => [
            {
                Header: "project Category",
                accessor: "projectCategory",
            },
            {
                Header: "Billing Entity Name",
                accessor: "entityName",
            },
            {
                Header: "Client Name",
                accessor: "clientName",
            },
            {
                Header: "Start Date",
                accessor: "startDate",
            },
            {
                Header: "End Date",
                accessor: "endDate",
            },
            {
                Header: "Manager Name",
                accessor: "managedBy",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'Upload Document', 'View Activity', 'delete']
    const subActions = []

    const initialValues = {
        id: '',
        name: '',
        engagementLetter: 0,
        ndaForm: 0,
        vendorForm: 0,
        GSTApplicable: 0,
        partnerPayout: 0,

        projectRoles: '',

        interactionMode: '',
        interactionDate: '',
        interactionTime: '',
        contactPersonId: '',
        durationMinutes: '',
        statusId: '',
        nextFollowUpDate: '',
        notes: '',

        documentName: '',

        fromContactList: '',
        activityoutputTemplateId: '',

        allActivity: 0,
        subActivityId: '',
        dateActivitys: '',
        notess: '',
        productCompletions: []
    };

    const handleUpdateActivity = async () => {
        try {
            const activityRes = await getProjectActivityDetails(ids);
            const activities = Array.isArray(activityRes?.data?.data) ? activityRes.data.data : [];
            setActivityDetails(activities);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
        }
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            if (showLogModal) {
                setLoadings(true);
                let postData = {
                    entity_id: ids,
                    log_type: 'project',
                    interaction_mode: values.interactionMode,
                    interaction_date: values.interactionDate,
                    interaction_time: values.interactionTime,
                    sub_activity_id: values.subActivityId,
                    contact_person_id: values.contactPersonId,
                    com_type_id: values.typeId,
                    notes: values.notes,
                    duration_minutes: values.durationMinutes,
                    status: values.statusId,
                    next_follow_up_date: values.nextFollowUpDate,
                }
                try {
                    const res = await postCommunicationLogSave(postData);
                    toast.success(res.data.message);
                    try {
                        const activityRes = await getProjectActivityDetails(ids);
                        const activities = Array.isArray(activityRes?.data?.data) ? activityRes.data.data : [];
                        setActivityDetails(activities);
                        setLoadings(false);
                    } catch (error) {
                        setLoadings(false);
                    }



                    setLoadings(false);
                    setShowLogModal(false);

                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (addModal) {
                setLoadings(true);
                if (step == 4) {
                    const rolePayload = buildRolesPayload(values.projectRoles, roleAssignments);
                    let postData = {
                        project_id: ids,
                        step: 'roles_setting',
                        data: rolePayload
                    };

                    try {
                        const res = await postProjectSave(postData);
                        toast.success(res.data.message);
                        setAddModal(false);
                        setIsEdit(false);
                        postUpdates();
                        formik.resetForm();
                        setStep(1);
                        setLoadings(false);
                    } catch (error) {
                        setLoadings(false);
                        toast.error(error.response?.data?.message || "Error submitting data");
                    }
                }


            }

            if (uploadDocument) {
                setLoadings(true);
                const formData = new FormData();
                formData.append('project_id', ids);
                formData.append('title', values.documentName);
                if (files && files.length > 0) {
                    Array.from(files).forEach((file) => {
                        formData.append('files[]', file);
                    });
                }
                try {
                    const res = await postProjectDocumentSave(formData);
                    toast.success(res.data.message);
                    setLoadings(false);
                    setUploadDocument(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }

            if (sendEmailModal) {
                let postData = {
                    project_id: ids,
                    from_user_id: values.fromContactList,
                    to_user_ids: selectedIds,
                    cc_user_ids: ccselectedIds,
                    email_subject: values.subject,
                    email_body: emailBody,
                    document_file_ids: selectedDocument,
                    project_document_ids: selectedProjDocument,
                }

                try {
                    const res = await postProjectSendMail(postData);
                    toast.success(res.data.message);
                    setSendEmailModal(false);
                    handleUpdateActivity();
                    setLoadings(false);
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const addnew = async () => {
        setEditData([]);
        setLoadings(true);
        setIsEdit(false);
        let postData = {
            type: [
                "currency",
                "billing_entity",
                "project_category",
                "clients",
                "project_frequency",
                "project_complexity",
                "project_renewal_type",
                "accounting_standards"
            ],
            org_type_code: ''
        }
        try {
            const res = await postCommonMaster(postData);
            setCommonMaster(res.data.data);

            setStep(1);
            setLoadings(false);
            setAddModal(true);

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleEdit = async (rowData) => {
        setEditData([]);
        setLoadings(true);
        let postData = {
            type: [
                "currency",
                "billing_entity",
                "project_category",
                "clients",
                "project_frequency",
                "project_complexity",
                "project_renewal_type",
                "accounting_standards"
            ],
            org_type_code: ''
        }

        setIds(rowData.id);
        setFieldValue('id', rowData.id);
        setLoadings(true);
        try {
            const ress = await postCommonMaster(postData);
            setCommonMaster(ress.data.data);

            postProjectLists(rowData.id);
            postProductActivityLists(rowData.id);
            postProductRoleLists(rowData.id);

            try {
                const res = await getProjectDetails(rowData?.id);
                setEditData(res.data.data);
                setIds(res.data.data.project_id);
                setFieldValue('id', res.data.data.project_id);
                setFieldValue('projectRoles', res.data.data?.roles_setting?.role_level);




                if (res.data.data?.current_step == 'general_information') {
                    setStep(1)
                }
                if (res.data.data?.current_step == 'product_invoice_setting') {
                    setStep(2)
                }
                if (res.data.data?.current_step == 'billing_phase_setting') {
                    setStep(3)
                }
                if (res.data.data?.current_step == 'roles_setting') {
                    setStep(4)
                }

                setLoadings(false);
                setIsEdit(true);
                setAddModal(true);
            } catch (error) {
                setLoadings(false);
                setIsEdit(false);
                setAddModal(false);
            }
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.id);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deleteProject(values.id);
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdates();
            setFieldValue('id', '');
            setFieldValue('name', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    const handleView = async (rowData) => {
        setLoadings(true);
        setIds(rowData?.id);
        try {
            const res = await getProjectFullDetails(rowData?.id);
            setFullDetails(res.data.data);
            try {
                const activityRes = await getProjectActivityDetails(rowData?.id);
                const activities = Array.isArray(activityRes?.data?.data) ? activityRes.data.data : [];
                setActivityDetails(activities);
                setLoadings(false);
                setViewModal(true);
            } catch (error) {
                setLoadings(false);
                setViewModal(false);
            }
        } catch (error) {
            setLoadings(false);
            setViewModal(false);
        }

    };

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        setViewModal(false);
        setShowLogModal(false);
        setUploadDocument(false);
        setStep(1);
        formik.resetForm();
    };

    const handleAdds = async (id) => {
        let postData = {
            project_id: ids,
            sub_activity_id: id
        }
        try {
            const res = await postProjectActivityCompletionData(postData);
            setActivitysDetail(res.data.data);
            setLoadings(false);
            setActivityStatus(true);

            let dataActivity = res.data.data;

            setFieldValue('allActivity', res?.data?.data?.is_all_product ? 1 : 0);
            setFieldValue('subActivityId', res?.data?.data?.sub_activity_id);
            setFieldValue('dateActivitys', res?.data?.data?.completion_date);
            setFieldValue('notess', res?.data?.data?.notes);
            setFieldValue('productCompletions', res?.data?.data?.product_completion);

        } catch (error) {
            toast.error(error.response?.data?.message);
            setLoadings(false);
            setActivityStatus(false);
        }

        setActivityStatus(true)
    };

    const handleSubmitActivity = async () => {
        setLoadings(true);

        let postData = {
            project_id: ids,
            sub_activity_id: values.subActivityId,
            completion_date: values.dateActivitys,
            notes: values.notess,
            is_all_product: values.allActivity,
            products: values.productCompletions.map(item => ({
                proj_product_id: item.proj_product_id,
                completion_date: item.completion_date,
                notes: item.notes,
                is_closed: item.is_closed ? 1 : 0
            }))
        }
        try {
            const res = await postChangeActivityStatus(postData);
            toast.success(res.data.message);
            handleUpdateActivity();
            setLoadings(false);
            setActivityStatus(false)
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleAddsLog = async (subId) => {
        formik.resetForm();
        let postData = {
            entity_id: ids,
            log_type: "project"
        }
        setFieldValue('subActivityId', subId);
        try {
            const res = await postCommunicationLogDropdown(postData);
            setDropdownList(res.data.data);
            try {
                let postDataS = {
                    entity_id: ids,
                    log_type: "project",
                    sub_activity_id: subId,
                }
                const res = await postCommunicationLogHistory(postDataS);
                setLogHistory(res.data.data);
                handleUpdateActivity();
                setLoadings(false);
            } catch (error) {
                setLoadings(false);
                toast.error(error.response?.data?.message || "Error submitting data");
            }
            setShowLogModal(true);

        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }

    };

    const handleUploadDocument = async (rowData) => {
        formik.resetForm();
        setLoadings(true);
        setIds(rowData?.id);
        setFiles([]);
        setIsEdit(false);
        setDocumentList([]);
        try {
            const document = await getProjectDocument(rowData?.id);
            setDocumentList(document.data.data);
            setLoadings(false);
            setUploadDocument(true);
        } catch (error) {
            setLoadings(false);
        }
    };

    const deleteUploadDocument = async (id) => {
        setLoadings(true);
        try {
            const res = await deleteProjectDocuments(id);
            toast.success(res.data.message);
            try {
                const document = await getProjectDocument(ids);
                setDocumentList(document.data.data);
                setLoadings(false);
            } catch (error) {
                setLoadings(false);
            }
        } catch (error) {
            setLoadings(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const handleSendEmail = (id, subId) => {
        setActivityId(id);
        setActivityId(subId);

        const filtered = activityDetails
            .find(activity => activity.activity_id === id)
            ?.sub_activity
            .find(sub => sub.sub_activity_id === subId);

        setActivityEmails(filtered);
        setSendEmailModal(true);
    };

    const handleRoleToggle = (type, itemId, personId, roleId, checked, role) => {
        if (!role.is_multiple && checked === false) {
            setRoleAssignments(prev => {
                const currentItem = prev[type][itemId] || {};
                const otherHasIt = Object.entries(currentItem).some(
                    ([pid, roles]) => pid !== String(personId) && roles[roleId] === true
                );
                if (!otherHasIt) {
                    toast.warn(`Role "${role.name}" must be assigned to at least one person.`);
                    return prev; // no change
                }
                // Proceed to unset
                const newType = { ...prev[type] };
                if (newType[itemId] && newType[itemId][personId]) {
                    const newPerson = { ...newType[itemId][personId] };
                    delete newPerson[roleId];
                    newType[itemId][personId] = newPerson;
                }
                return { ...prev, [type]: newType };
            });
            return;
        }

        // For checkbox or radio setting to true
        setRoleAssignments(prev => {
            const newType = { ...prev[type] };
            if (!newType[itemId]) newType[itemId] = {};
            if (!newType[itemId][personId]) newType[itemId][personId] = {};

            // If it's a radio (is_multiple false) and we are setting to true, remove this role from all other persons
            if (!role.is_multiple && checked === true) {
                const currentItem = newType[itemId];
                Object.keys(currentItem).forEach(pid => {
                    if (pid !== String(personId) && currentItem[pid]?.[roleId]) {
                        const updatedPerson = { ...currentItem[pid] };
                        delete updatedPerson[roleId];
                        currentItem[pid] = updatedPerson;
                    }
                });
            }

            // Now set the role for the current person
            newType[itemId][personId] = {
                ...newType[itemId][personId],
                [roleId]: checked
            };
            return { ...prev, [type]: newType };
        });
    };

    const buildRolesPayload = (level, assignments) => {
        const formatPersonRoles = (assignmentsObj, itemId) => {
            const itemAssignments = assignmentsObj[itemId] || {};
            const result = Object.entries(itemAssignments)
                .map(([personId, roles]) => {
                    const centri_ids = Object.entries(roles)
                        .filter(([, val]) => val === true)
                        .map(([roleId]) => parseInt(roleId));
                    return centri_ids.length ? { contact_person_id: parseInt(personId), centri_ids } : null;
                })
                .filter(v => v);
            return result;
        };

        if (level == 'project') {
            return {
                role_level: level,
                client_centric: formatPersonRoles(assignments.client, 'project'),
                billing_entity_centric: formatPersonRoles(assignments.billing, 'project'),
            };
        } else {

            let items = [];
            let roleBreakup;

            if (level == 'category') {
                items = rolesData.category || [];
                roleBreakup = items.map(item => {
                    const id = item.category_id;
                    const client = formatPersonRoles(assignments.client, id);
                    const billing = formatPersonRoles(assignments.billing, id);
                    return { id, client_centric: client, billing_entity_centric: billing };
                }).filter(breakup => breakup.client_centric.length || breakup.billing_entity_centric.length);
            }

            if (level == 'sub_category') {
                items = rolesData.sub_category || [];
                roleBreakup = items.map(item => {
                    const id = item.sub_category_id;
                    const client = formatPersonRoles(assignments.client, id);
                    const billing = formatPersonRoles(assignments.billing, id);
                    return { id, client_centric: client, billing_entity_centric: billing };
                }).filter(breakup => breakup.client_centric.length || breakup.billing_entity_centric.length);
            }

            if (level == 'product') {
                items = rolesData.product || [];
                roleBreakup = items.map(item => {
                    const id = item.product_id;
                    const client = formatPersonRoles(assignments.client, id);
                    const billing = formatPersonRoles(assignments.billing, id);
                    return { id, client_centric: client, billing_entity_centric: billing };
                }).filter(breakup => breakup.client_centric.length || breakup.billing_entity_centric.length);
            }

            return { role_level: level, role_breakup: roleBreakup };
        }
    };

    const RenderRoleTables = ({ itemId, level, clientRoles, billingRoles }) => {
        const clientColumns = useMemo(() => {
            const base = [
                { Header: "Name", accessor: "name", width: 200 },
                { Header: "Email id", accessor: "email", width: 200 },
                { Header: "Mobile Number", accessor: "mobile_number", width: 200 },
            ];
            const roleCols = clientRoles.map(role => ({
                Header: role.name,
                id: `client_${itemId}_${role.id}`,
                width: 80,
                Cell: ({ row }) => {
                    const personId = row.original.contact_person_id;
                    const isChecked = roleAssignments.client[itemId]?.[personId]?.[role.id] || false;
                    if (role.is_multiple) {
                        return (
                            <span className="chk">
                                <input
                                    type="checkbox"
                                    className="chkbox"
                                    checked={isChecked}
                                    onChange={e => handleRoleToggle('client', itemId, personId, role.id, e.target.checked, role)}
                                />
                            </span>
                        );
                    } else {
                        return (
                            <div className="radioBox d-flex justify-content-center">
                                <input
                                    type="radio"
                                    name={`client_radio_${itemId}_${role.id}`}
                                    checked={isChecked}
                                    onChange={() => handleRoleToggle('client', itemId, personId, role.id, true, role)}
                                />
                                <span className="rdoMark"></span>
                            </div>
                        );
                    }
                }
            }));
            return [...base, ...roleCols];
        }, [clientRoles, roleAssignments.client, itemId]);

        const billingColumns = useMemo(() => {
            const base = [
                { Header: "Name", accessor: "name", width: 200 },
                { Header: "Email id", accessor: "email", width: 200 },
                { Header: "Mobile Number", accessor: "mobile_number", width: 200 },
            ];
            const roleCols = billingRoles.map(role => ({
                Header: role.name,
                id: `billing_${itemId}_${role.id}`,
                width: 80,
                Cell: ({ row }) => {
                    const personId = row.original.contact_person_id;
                    const isChecked = roleAssignments.billing[itemId]?.[personId]?.[role.id] || false;
                    if (role.is_multiple) {
                        return (
                            <span className="chk">
                                <input
                                    type="checkbox"
                                    className="chkbox"
                                    checked={isChecked}
                                    onChange={e => handleRoleToggle('billing', itemId, personId, role.id, e.target.checked, role)}
                                />
                            </span>
                        );
                    } else {
                        return (
                            <div className="radioBox d-flex justify-content-center">
                                <input
                                    type="radio"
                                    name={`billing_radio_${itemId}_${role.id}`}
                                    checked={isChecked}
                                    onChange={() => handleRoleToggle('billing', itemId, personId, role.id, true, role)}
                                />
                                <span className="rdoMark"></span>
                            </div>
                        );
                    }
                }
            }));
            return [...base, ...roleCols];
        }, [billingRoles, roleAssignments.billing, itemId]);

        return (
            <>
                <div className='fieldsets notAddnew'>
                    <div className='fieldsets-title'>Client Centric</div>
                    <Tables columns={clientColumns} data={clientPersons} actions={[]} subActions={[]} />
                </div>
                <div className='fieldsets notAddnew'>
                    <div className='fieldsets-title'>Billing Entity Centric</div>
                    <Tables columns={billingColumns} data={billingPersons} actions={[]} subActions={[]} />
                </div>
            </>
        );
    };

    const getItemsForLevel = (level) => {
        if (level == 'project') return ['project'];
        if (level == 'category') return rolesData.category || [];
        if (level == 'sub_category') return rolesData.sub_category || [];
        if (level == 'product') return rolesData.product || [];
        return [];
    };

    const parseExistingAssignments = (existingRoleSetting) => {
        const clientAssign = {};
        const billingAssign = {};

        const initPersons = (itemId) => {
            if (!clientAssign[itemId]) clientAssign[itemId] = {};
            if (!billingAssign[itemId]) billingAssign[itemId] = {};
            clientPersons.forEach(p => {
                if (!clientAssign[itemId][p.contact_person_id]) clientAssign[itemId][p.contact_person_id] = {};
            });
            billingPersons.forEach(p => {
                if (!billingAssign[itemId][p.contact_person_id]) billingAssign[itemId][p.contact_person_id] = {};
            });
        };

        const applyCentric = (itemId, centricArray, type) => {
            initPersons(itemId);
            centricArray.forEach(({ contact_person_id, centri_ids }) => {
                centri_ids.forEach(roleId => {
                    if (type === 'client') {
                        clientAssign[itemId][contact_person_id][roleId] = true;
                    } else {
                        billingAssign[itemId][contact_person_id][roleId] = true;
                    }
                });
            });
        };

        const level = existingRoleSetting.role_level;
        if (level == 'project') {
            // Direct top‑level centric arrays
            applyCentric('project', existingRoleSetting.client_centric || [], 'client');
            applyCentric('project', existingRoleSetting.billing_entity_centric || [], 'billing');
        } else {
            // Use role_breakup
            const breakup = existingRoleSetting.role_breakup || [];
            breakup.forEach(item => {
                applyCentric(item.id, item.client_centric || [], 'client');
                applyCentric(item.id, item.billing_entity_centric || [], 'billing');
            });
        }

        return { client: clientAssign, billing: billingAssign };
    };

    const initializeEmptyAssignments = (level) => {
        const items = getItemsForLevel(level);
        const clientAssign = {};
        const billingAssign = {};

        const initItem = (itemId) => {
            clientAssign[itemId] = {};
            billingAssign[itemId] = {};
            clientPersons.forEach(p => {
                clientAssign[itemId][p.contact_person_id] = {};
            });
            billingPersons.forEach(p => {
                billingAssign[itemId][p.contact_person_id] = {};
            });
        };

        items.forEach(item => {
            if (typeof item === 'string') {
                initItem(item); // 'project'
            } else {
                const id = item.category_id || item.sub_category_id || item.product_id;
                initItem(id);
            }
        });

        return { client: clientAssign, billing: billingAssign };
    };

    useEffect(() => {
        if (step !== 4 || !addModal || clientPersons.length === 0 || billingPersons.length === 0) return;

        if (isEdit && editData && editData.roles_setting) {
            const parsed = parseExistingAssignments(editData.roles_setting);
            setRoleAssignments(parsed);
        } else if (!isEdit && values.projectRoles) {
            const empty = initializeEmptyAssignments(values.projectRoles);
            setRoleAssignments(empty);
        }
    }, [step, addModal, isEdit, editData, clientPersons, billingPersons, values.projectRoles, rolesData]);

    const postRenderEmailBody = async (postData) => {
        setLoadings(true);
        setEmailBody('');
        setFieldValue('subject', '');
        try {
            const res = await postEmailTemplateRenderBody(postData);
            setEmailBody(res.data.data?.body || '');
            setFieldValue('subject', res.data.data?.subject);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
        }
    };

    const postDocumentFileLists = async (postData) => {
        setLoadings(false);
        try {
            const res = await postDocumentFileList(postData);
            setDocumentListData(res.data.data);
            setLoadings(false);
        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
            setLoadings(false);
        }
    };

    useEffect(() => {
        if (sendEmailModal) {
            setLoadings(false);
            let postData = {
                billing_entity_id: fullDetails?.general_information?.billing_entity_id,
                email_template_id: values?.activityoutputTemplateId
            }
            postDocumentFileLists(postData);

        }
    }, [values?.activityoutputTemplateId]);

    useEffect(() => {
        if (sendEmailModal) {
            let postData = {
                project_id: ids,
                email_template_id: values?.activityoutputTemplateId,
                from_person_id: values?.fromContactList,
                document_file_ids: selectedDocument
            }
            postRenderEmailBody(postData);
        }
    }, [values?.activityoutputTemplateId, values?.fromContactList, selectedDocument]);

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />

            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Project" active="Project" items={['Home']} />
                    <Row>
                        <Col md={12}>
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Project</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <button type='button' className='btn btn-primary' onClick={() => addnew()}>Add New</button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                        onView={handleView}
                                        onUploadDocument={handleUploadDocument}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={isEdit ? 'Edit Product' : 'Add New'}
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <div>
                    {step <= 4 &&
                        <StepOne
                            ids={ids}
                            setIds={setIds}
                            step={step}
                            setStep={setStep}
                            isLoadings={isLoadings}
                            setLoadings={setLoadings}
                            Toast={toast}
                            postProjectLists={postProjectLists}
                            commonMaster={commonMaster}
                            postUpdates={postUpdates}
                            editData={editData}
                        />
                    }
                    {step >= 2 && step <= 4 &&
                        <StepTwo
                            ids={ids}
                            setIds={setIds}
                            step={step}
                            setStep={setStep}
                            isLoadings={isLoadings}
                            setLoadings={setLoadings}
                            Toast={toast}
                            postProductActivityLists={postProductActivityLists}
                            projectList={projectList}
                            commonMaster={commonMaster}
                            postUpdates={postUpdates}
                            editData={editData}
                        />
                    }
                    {step >= 3 && step <= 4 &&
                        <StepThree
                            ids={ids}
                            setIds={setIds}
                            step={step}
                            setStep={setStep}
                            isLoadings={isLoadings}
                            setLoadings={setLoadings}
                            Toast={toast}
                            postProductRoleLists={postProductRoleLists}
                            activityList={activityList}
                            postUpdates={postUpdates}
                            editData={editData}
                        />
                    }

                    {/* ===================== STEP 4 - FULL CODE ===================== */}
                    {step == 4 && (
                        <form onSubmit={handleSubmit} autoComplete="off">
                            <div className='fieldsets cols_5'>
                                <div className='fieldsets-title'>Project Roles</div>
                                <Row>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <label className="form-label">Project Roles</label>
                                            <ul className='radiolist'>
                                                <li><div className='radioBox'><input type="radio" name="projectRoles" value="project" checked={values.projectRoles === 'project'} onChange={handleChange} /><span className='rdoMark'></span><label>Project Level</label></div></li>
                                                <li><div className='radioBox'><input type="radio" name="projectRoles" value="product" checked={values.projectRoles === 'product'} onChange={handleChange} /><span className='rdoMark'></span><label>Product Name Level</label></div></li>
                                                <li><div className='radioBox'><input type="radio" name="projectRoles" value="category" checked={values.projectRoles === 'category'} onChange={handleChange} /><span className='rdoMark'></span><label>Product Category Level</label></div></li>
                                                <li><div className='radioBox'><input type="radio" name="projectRoles" value="sub_category" checked={values.projectRoles === 'sub_category'} onChange={handleChange} /><span className='rdoMark'></span><label>Product Sub Category Level</label></div></li>
                                            </ul>
                                            {errors.projectRoles && touched.projectRoles && <p className="errormsg">{errors.projectRoles}</p>}
                                        </div>
                                    </Col>
                                </Row>

                                {values.projectRoles === 'project' && rolesData.project && (
                                    <div className='fieldsets notAddnew'>
                                        <div className='fieldsets-title'>Project Level Roles</div>
                                        <RenderRoleTables
                                            itemId="project"
                                            level="project"
                                            clientRoles={rolesData.project.client_centric || []}
                                            billingRoles={rolesData.project.billing_entity_centric || []}
                                        />
                                    </div>
                                )}

                                {values.projectRoles === 'category' && rolesData.category?.map(cat => (
                                    <div key={cat.category_id} className='fieldsets notAddnew' style={{ marginTop: 20 }}>
                                        <div className='fieldsets-title'>Category: {cat.category_name}</div>
                                        <RenderRoleTables
                                            itemId={cat.category_id}
                                            level="category"
                                            clientRoles={cat.client_centric || []}
                                            billingRoles={cat.billing_entity_centric || []}
                                        />
                                    </div>
                                ))}

                                {values.projectRoles === 'sub_category' && rolesData.sub_category?.map(sub => (
                                    <div key={sub.sub_category_id} className='fieldsets notAddnew' style={{ marginTop: 20 }}>
                                        <div className='fieldsets-title'>Sub‑Category: {sub.sub_category_name}</div>
                                        <RenderRoleTables
                                            itemId={sub.sub_category_id}
                                            level="sub_category"
                                            clientRoles={sub.client_centric || []}
                                            billingRoles={sub.billing_entity_centric || []}
                                        />
                                    </div>
                                ))}

                                {values.projectRoles === 'product' && rolesData.product?.map(prod => (
                                    <div key={prod.product_id} className='fieldsets notAddnew' style={{ marginTop: 20 }}>
                                        <div className='fieldsets-title'>Product: {prod.product_name}</div>
                                        <RenderRoleTables
                                            itemId={prod.product_id}
                                            level="product"
                                            clientRoles={prod.client_centric || []}
                                            billingRoles={prod.billing_entity_centric || []}
                                        />
                                    </div>
                                ))}
                            </div>

                            <div className='modalfooters'>
                                <div className='button-boxs grid'>
                                    <button type="submit" className='btn btn-primary'>Save</button>
                                    <button type="button" onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                                </div>
                            </div>
                        </form>
                    )}
                    {/* ===================== END STEP 4 ===================== */}
                </div>
            </Modals>

            <Modals
                show={viewModal}
                handleClose={() => setViewModal(false)}
                title="View"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <div className='valutionsboxs'>
                    <div className='fieldsets'>
                        <div className='fieldsets-title'>Project Information</div>
                        <div style={{ paddingTop: 5 }}>
                            <div className="table-responsive">
                                <table className="table table-bordered text-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>Project Name</th>
                                            <th>Billing Entity Name</th>
                                            <th>Client Name</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Managed By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{fullDetails?.general_information?.proj_category}</td>
                                            <td>{fullDetails?.general_information?.billing_entity_name}</td>
                                            <td>{fullDetails?.general_information?.client_name}</td>
                                            <td>{fullDetails?.general_information?.start_date}</td>
                                            <td>{fullDetails?.general_information?.end_date}</td>
                                            <td style={{ textAlign: 'center' }}>{fullDetails?.general_information?.project_manager}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className='fieldsets'>
                        <div className='fieldsets-title'>Product Information</div>
                        <div style={{ paddingTop: 5 }}>
                            <div className="table-responsive">
                                <table className="table table-bordered text-nowrap mb-0">
                                    <thead>
                                        <tr>
                                            <th>Product Category</th>
                                            <th>Product Sub Category</th>
                                            <th>Product</th>
                                            <th>Start Date</th>
                                            <th>End Date</th>
                                            <th>Regulatory Applicable Standard</th>
                                            <th>Employee Count</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fullDetails?.project_products?.map((item) => (
                                            <tr>
                                                <td>{item?.category?.category_name}</td>
                                                <td>{item?.sub_category?.sub_category_name}</td>
                                                <td>{item?.product?.product_name}</td>
                                                <td>{item?.start_date}</td>
                                                <td>{item?.end_date}</td>
                                                <td>{item?.accounts_standard?.name}</td>
                                                <td>{item?.employee_count}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className='fieldsets'>
                        <div className='fieldsets-title'>{proName} Activity Status</div>
                        <div className='activityboxs_grid'>
                            <Accordion defaultActiveKey="1_0">
                                <Row>
                                    {activityDetails?.map((item, index) => (
                                        <Col md={4} key={item.activity_id}>
                                            <div className='activityCard'>
                                                <div className='cardHed'>
                                                    <h4>{item?.activity_name}</h4>
                                                </div>
                                                <div className='cardBody'>
                                                    {item?.is_sub_activity ? <>
                                                        {item?.sub_activity?.map((sub, ind) => (
                                                            <Accordion.Item eventKey={`${item.activity_id}_${ind}`} className={sub?.status}>
                                                                <Accordion.Header>
                                                                    <div className='statusBoxs open'>
                                                                        {sub?.status == 'complete' ? <FaRegCheckCircle /> : <FaRegDotCircle />}
                                                                    </div>{sub?.sub_activity_name}
                                                                </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <div className='activityContent'>
                                                                        {sub?.last_communication?.last_follow_up_by && (
                                                                            <>
                                                                                <ul>
                                                                                    <li>Last Follow up By</li>
                                                                                    <li>:</li>
                                                                                    <li>{sub.last_communication.last_follow_up_by}</li>
                                                                                </ul>
                                                                                <ul>
                                                                                    <li>Last Follow up Date</li>
                                                                                    <li>:</li>
                                                                                    <li>{sub.last_communication.last_follow_up_date}</li>
                                                                                </ul>
                                                                                <p><b>Log Text : </b>{sub.last_communication.log_text}</p>
                                                                            </>
                                                                        )}
                                                                        <div className='buttonboxs grids'>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Add Activity</Tooltip>}>
                                                                                <button className='btn btn-primary' onClick={() => handleAdds(sub?.sub_activity_id)}>
                                                                                    <FaPlus />
                                                                                </button>
                                                                            </OverlayTrigger>

                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Send Email</Tooltip>}>
                                                                                <button className='btn btn-primary' onClick={() => handleSendEmail(item.activity_id, sub?.sub_activity_id)}>
                                                                                    <FaEnvelopeOpenText />
                                                                                </button>
                                                                            </OverlayTrigger>

                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Communication Log</Tooltip>}>
                                                                                <button className='btn btn-primary' onClick={() => handleAddsLog(sub?.sub_activity_id)}>
                                                                                    <FaSyncAlt />
                                                                                    <div className='counts'><p>{sub?.communication_count}</p></div>
                                                                                </button>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        ))}
                                                    </> : null}
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </Modals>

            <Modals
                show={showLogModal}
                handleClose={() => setShowLogModal(false)}
                title="Communication Log"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={8}>
                            <Row>
                                <Col md={12}>
                                    <div className="form-group">
                                        <div className="table-responsive">
                                            <table className="table table-bordered text-nowrap mb-0">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: 60 }}></th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>Email Id</th>
                                                        <th className="txt-left">Mobile Number</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dropdownList?.contact_person?.map((item) => (
                                                        <tr key={`tab_content_person_${item?.contact_person_id}`}>
                                                            <td className='rdotd'>
                                                                <input
                                                                    type="radio"
                                                                    name="contactPersonId"
                                                                    value={item?.contact_person_id}
                                                                    checked={values.contactPersonId == item?.contact_person_id}
                                                                    onChange={(e) => { setFieldValue('contactPersonId', e.target.checked ? item?.contact_person_id : ''); }}
                                                                    onBlur={handleBlur}
                                                                />
                                                            </td>
                                                            <td>{item?.first_name}</td>
                                                            <td>{item?.last_name}</td>
                                                            <td>{item?.email}</td>
                                                            <td>{item?.mobile_number}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="form-group">
                                        <div className='d-flex align-items-center'>
                                            <label className='mb-0'>Communication Types :</label>
                                            <div className='typeList'>
                                                {dropdownList?.communication_type?.map((item) => (
                                                    <div className='litBoxs' key={`typeIds_${item?.com_type_id}`}>
                                                        <input
                                                            type="radio"
                                                            name="typeId"
                                                            value={item?.com_type_id}
                                                            checked={values.typeId == item?.com_type_id}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setFieldValue('typeId', item?.com_type_id);
                                                                    setStatusList(item?.statuses)
                                                                }
                                                            }}
                                                            onBlur={handleBlur}
                                                        />
                                                        <div className='listContent'>
                                                            <img src={item?.com_type_icon} className="typeIo" alt={item?.com_type_name} title={item?.com_type_name} />
                                                            <p>{item?.com_type_name}</p>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">interaction Date</label>
                                        <DateToDayFild
                                            value={values.interactionDate}
                                            onChange={(date) => setFieldValue('interactionDate', date)}
                                            isMin={false}
                                            isMax={true}
                                        />
                                        {errors.interactionDate && touched.interactionDate && (
                                            <p className="errormsg">{errors.interactionDate}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">interaction Time</label>
                                        <TimeFild
                                            value={values.interactionTime}
                                            onChange={(time) => setFieldValue('interactionTime', time)}
                                            format="local"
                                        />
                                        {errors.interactionTime && touched.interactionTime && (
                                            <p className="errormsg">{errors.interactionTime}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Select interaction Mode</label>
                                        <SelectFild
                                            Firstop='Select Interaction Mode'
                                            selectName="interactionMode"
                                            options={dropdownList?.interaction_mode}
                                            value={values.interactionMode}
                                            onChange={(selectedOption) => setFieldValue("interactionMode", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.interactionMode && touched.interactionMode && (
                                            <p className="errormsg">{errors.interactionMode}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Select Status</label>
                                        <SelectFild
                                            Firstop='Select Status'
                                            selectName="statusId"
                                            options={statusList}
                                            value={values.statusId}
                                            onChange={(selectedOption) => setFieldValue("statusId", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.statusId && touched.statusId && (
                                            <p className="errormsg">{errors.statusId}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">duration Minutes</label>
                                        <input
                                            type='text'
                                            id="durationMinutes"
                                            name="durationMinutes"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.durationMinutes}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.durationMinutes && touched.durationMinutes && (
                                            <p className="errormsg">{errors.durationMinutes}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label className="form-label">Next Scheduled Date</label>
                                        <DateToDayFild
                                            value={values.nextFollowUpDate}
                                            onChange={(date) => setFieldValue('nextFollowUpDate', date)}
                                            isMin={true}
                                            isMax={false}
                                        />
                                        {errors.nextFollowUpDate && touched.nextFollowUpDate && (
                                            <p className="errormsg">{errors.nextFollowUpDate}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="form-group">
                                        <label className="form-label">Notes</label>
                                        <textarea
                                            id="notes"
                                            name="notes"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.notes}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.notes && touched.notes && (
                                            <p className="errormsg">{errors.notes}</p>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <div className="ScheduledBlock">
                                <h1>Communication History</h1>
                                <div className="Scheduledbox">
                                    <ul>
                                        {logHistory?.map((item) => (
                                            <li key={item?.interaction_id}>
                                                <div className='scheduled-date'>
                                                    <h6>{item?.interaction_datetime?.split(" ")?.[0]}</h6>
                                                    <p>{item?.interaction_datetime?.split(" ")?.[1]}</p>
                                                </div>
                                                <div className='scheduled-io'>
                                                    <FaCheckCircle />
                                                </div>
                                                <div className='scheduled-content'>
                                                    <h4>{item?.interaction_to?.name}</h4>
                                                    <p>{item?.status?.status_name}</p>
                                                    <p>Next Follow-up Date: {item?.next_follow_up_date}</p>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Save</button>
                            <button type='button' onClick={() => setShowLogModal(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={uploadDocument}
                handleClose={() => setUploadDocument(false)}
                title="Upload Document"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Document Name</label>
                                <input
                                    type='text'
                                    id="documentName"
                                    name="documentName"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.documentName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.documentName && touched.documentName && (
                                    <p className="errormsg">{errors.documentName}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='fieldsets'>
                                <div className='fieldsetsboxs'>
                                    <h6>Upload</h6>
                                </div>
                                <div className="formsBox upload-container">
                                    <div
                                        className="drop-zone"
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                    >
                                        <p>Drag & Drop Here</p>
                                        <p>or</p>
                                        <button
                                            type="button"
                                            onClick={() => fileInputRef.current?.click()}
                                            className="select-button btn btn-primary"
                                        >
                                            Select Files
                                        </button>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/*,.pdf"
                                            multiple
                                            onChange={handleFileSelect}
                                            style={{ display: 'none' }}
                                        />
                                    </div>


                                    <div className="previewsimges col_3">
                                        {documentList.length > 0 && (
                                            <>
                                                {documentList?.map((file) => (
                                                    <div className='imageboxs'>
                                                        <div className='imgs pdfs'>
                                                            <div>
                                                                <div className='acbox'>
                                                                    <button type='button' onClick={() => deleteUploadDocument(file.project_document_id)} className='btn btn-removed'><FaTrashAlt /></button>
                                                                </div>
                                                                <div className="pdf-icon">
                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                </div>
                                                                <p>{file.file_name}</p>
                                                                <a href={file.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                        {files.length > 0 && (
                                            <>
                                                {files?.map((file, index) => (
                                                    <div className='imageboxs'>
                                                        <div className='imgs pdfs'>
                                                            <div>
                                                                <div className='acbox'>
                                                                    <button type='button' onClick={() => removeFile(index)} className='btn btn-removed'><FaTrashAlt /></button>
                                                                </div>
                                                                <div className="pdf-icon">
                                                                    <FaFilePdf size={48} color="#e74c3c" />
                                                                </div>
                                                                {file?.file_name ?
                                                                    <>
                                                                        <p>{file.file_name}</p>
                                                                        <a href={file.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a>
                                                                    </>
                                                                    : <>
                                                                        <p> {file.name}</p>
                                                                        {/* <a href={pdfUrl} target="_blank" className='btn btn-primary' rel="noopener noreferrer">view Pdf</a> */}
                                                                    </>}

                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Upload</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={sendEmailModal}
                handleClose={() => setSendEmailModal(false)}
                title="Send Mail"
                textColor='#000'
                size='xl'
                centered={true}
                backdrop={true}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">From</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activityEmails?.billing_entity_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="radio"
                                                            name="fromContactList"
                                                            value={item?.user_id}
                                                            checked={values.fromContactList == item?.user_id}
                                                            onChange={(e) => { setFieldValue('fromContactList', e.target.checked ? item?.user_id : ''); }}
                                                            onBlur={handleBlur}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">To</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activityEmails?.client_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="checkbox"
                                                            value={item.user_id}
                                                            checked={selectedIds.includes(item.user_id)}
                                                            onChange={(e) => {
                                                                const id = item.user_id;
                                                                setSelectedIds(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, id]
                                                                        : prev.filter(pid => pid !== id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">CC</label>
                                <div className="table-responsive">
                                    <table className="table table-bordered text-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ width: 60 }}></th>
                                                <th style={{ width: 350 }}>First Name</th>
                                                <th style={{ width: 350 }}>Last Name</th>
                                                <th>Email Id</th>
                                                <th style={{ width: 350 }} className="txt-left">Mobile Number</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activityEmails?.billing_entity_person?.map((item) => (
                                                <tr key={`tab_content_person_${item?.user_id}`}>
                                                    <td className='rdotd'>
                                                        <input
                                                            type="checkbox"
                                                            value={item.user_id}
                                                            checked={ccselectedIds.includes(item.user_id)}
                                                            onChange={(e) => {
                                                                const id = item.user_id;
                                                                setccSelectedIds(prev =>
                                                                    e.target.checked
                                                                        ? [...prev, id]
                                                                        : prev.filter(pid => pid !== id)
                                                                );
                                                            }}
                                                        />
                                                    </td>
                                                    <td>{item?.first_name}</td>
                                                    <td>{item?.last_name}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.mobile_number}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Select Email Template</label>
                                <SelectFild
                                    Firstop='Select Email Template'
                                    selectName="activityoutputTemplateId"
                                    options={activityEmails?.email_template}
                                    value={values.activityoutputTemplateId}
                                    onChange={(selectedOption) => {
                                        setFieldValue('activityoutputTemplateId', selectedOption?.value || "");
                                    }}
                                    onBlur={handleBlur}
                                />
                                {errors.activityoutputTemplateId && touched.activityoutputTemplateId && (
                                    <p className="errormsg">{errors.activityoutputTemplateId}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Subject</label>
                                <input
                                    type='text'
                                    id="subject"
                                    name="subject"
                                    className="form-control"
                                    value={values.subject}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.subject && touched.subject && (
                                    <p className="errormsg">{errors.subject}</p>
                                )}
                            </div>
                        </Col>

                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Email Body</label>
                                <CKEditor
                                    editor={ClassicEditor}
                                    data={emailBody}
                                    config={{
                                        licenseKey: 'GPL',
                                        plugins: [
                                            Essentials,
                                            Paragraph,
                                            Heading,
                                            Bold,
                                            Italic,
                                            Underline,
                                            Strikethrough,
                                            Code,
                                            Subscript,
                                            Superscript,
                                            Font,
                                            FontFamily,
                                            FontSize,
                                            FontColor,
                                            FontBackgroundColor,
                                            Alignment,
                                            Link,
                                            List,
                                            TodoList,
                                            BlockQuote,
                                            Indent,
                                            IndentBlock,
                                            Table,
                                            TableToolbar,
                                            TableProperties,
                                            TableCellProperties,
                                            HorizontalLine,
                                            RemoveFormat,
                                            SpecialCharacters,
                                            SourceEditing,
                                            GeneralHtmlSupport
                                        ],

                                        toolbar: [
                                            'undo', 'redo',
                                            '|',
                                            'heading',
                                            '|',
                                            'fontFamily',
                                            'fontSize',
                                            'fontColor',
                                            'fontBackgroundColor',
                                            '|',
                                            'bold',
                                            'italic',
                                            'underline',
                                            'strikethrough',
                                            '|',
                                            'alignment',
                                            '|',
                                            'bulletedList',
                                            'numberedList',
                                            'todoList',
                                            '|',
                                            'outdent',
                                            'indent',
                                            '|',
                                            'link',
                                            'insertTable',
                                            '|',
                                            'blockQuote',
                                            'horizontalLine',
                                            'removeFormat',
                                            '|',
                                            'sourceEditing'
                                        ],

                                        table: {
                                            contentToolbar: [
                                                'tableColumn',
                                                'tableRow',
                                                'mergeTableCells',
                                                'tableProperties',
                                                'tableCellProperties'
                                            ]
                                        },

                                        htmlSupport: {
                                            allow: [
                                                {
                                                    name: /.*/,
                                                    attributes: true,
                                                    classes: true,
                                                    styles: true
                                                }
                                            ]
                                        }
                                    }}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        setEmailBody(data);
                                    }}
                                    onReady={(editor) => {
                                        console.log('Editor is ready to use!', editor);
                                    }}
                                    onBlur={(event, editor) => {
                                        console.log('Blur.', editor);
                                    }}
                                    onFocus={(event, editor) => {
                                        console.log('Focus.', editor);
                                    }}
                                />
                            </div>
                        </Col>
                        {documentListData?.common_document?.length > 0 && (
                            <Col md={12}>
                                <div className='fieldsets'>
                                    <div className='fieldsets-title'>Common Document</div>
                                    <div className='attachmentsList'>
                                        <ul>
                                            {documentListData?.common_document?.map((item) => (
                                                <li>
                                                    <div className='listcards'>
                                                        <h4>{item?.document_title}</h4>
                                                        <ul>
                                                            {item?.files?.map((files) => (
                                                                <li>
                                                                    <div className='attBox'>
                                                                        <div className="chkBox">
                                                                            <input
                                                                                type="checkbox"
                                                                                value={files.document_file_id}
                                                                                checked={selectedDocument.includes(files.document_file_id)}
                                                                                onChange={(e) => {
                                                                                    const id = files.document_file_id;
                                                                                    setSelectedDocument(prev =>
                                                                                        e.target.checked
                                                                                            ? [...prev, id]
                                                                                            : prev.filter(pid => pid !== id)
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </div>
                                                                        <div className="pdf-icon">
                                                                            <FaFilePdf size={16} color="#e74c3c" />
                                                                        </div>
                                                                        <p>{files?.file_name}</p>
                                                                        <a href={files?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        )}
                        {fullDetails?.documents?.length > 0 && (
                            <Col md={12}>
                                <div className='fieldsets'>
                                    <div className='fieldsets-title'>Upload Document List</div>
                                    <div className='attachmentsList'>
                                        <ul>
                                            {fullDetails?.documents?.map((files) => (
                                                <li>
                                                    <div className='attBox'>
                                                        <div className="chkBox">
                                                            <input
                                                                type="checkbox"
                                                                value={files.project_document_id}
                                                                checked={selectedProjDocument.includes(files.project_document_id)}
                                                                onChange={(e) => {
                                                                    const id = files.project_document_id;
                                                                    setSelectedProjDocument(prev =>
                                                                        e.target.checked
                                                                            ? [...prev, id]
                                                                            : prev.filter(pid => pid !== id)
                                                                    );
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="pdf-icon">
                                                            <FaFilePdf size={16} color="#e74c3c" />
                                                        </div>
                                                        <p>{files?.file_name}</p>
                                                        <a href={files?.file_url} target="_blank" className='btn btn-primary' rel="noopener noreferrer"><FaEye /></a>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>Send</button>
                            <button type='button' onClick={() => setSendEmailModal(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            <Modals
                show={activityStatus}
                handleClose={() => setActivityStatus(false)}
                title="Add"
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={() => setActivityStatus(false)}
            >
                <div className='formsData'>
                    <Row>
                        <Col md={3}>
                            {values.allActivity == 1 &&
                                <div style={{ marginTop: 30 }}></div>
                            }
                            <div className="form-group">
                                <div className='d-flex align-items-center'>
                                    <label className="form-label">All Products</label>
                                    <div className="switchs" style={{ marginLeft: 10 }}>
                                        <input
                                            type="checkbox"
                                            name="allActivity"
                                            className="form-control"
                                            checked={values.allActivity === 1}
                                            onChange={(e) =>
                                                setFieldValue('allActivity', e.target.checked ? 1 : 0)
                                            }
                                            onBlur={handleBlur}
                                        />
                                        <span className="slider round"></span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        {values.allActivity == 1 &&
                            <>
                                <Col md={3}>
                                    <div className="form-group">
                                        <label className="form-label">Date</label>
                                        <DateFild
                                            value={values.dateActivitys}
                                            onChange={(date) => setFieldValue('dateActivitys', date)}
                                        />
                                        {errors.dateActivitys && touched.dateActivitys && (
                                            <p className="errormsg">{errors.dateActivitys}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label className="form-label">Notes</label>
                                        <textarea
                                            id="notess"
                                            name="notess"
                                            className="form-control"
                                            autoComplete='off'
                                            value={values.notess}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.notes && touched.notes && (
                                            <p className="errormsg">{errors.notes}</p>
                                        )}
                                    </div>
                                </Col>
                            </>
                        }
                    </Row>
                    {values.allActivity == 0 && values.productCompletions.length > 0 && (
                        <div className='fieldsets'>
                            <div className='fieldsets-title'>Sub Category Activity Status</div>
                            <table className="table table-bordered text-nowrap mb-0">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>Notes</th>
                                        <th width={100}>is Closed</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {values.productCompletions.map((item, index) => (
                                        <tr key={item.proj_product_id}>
                                            <th className='invoiceDataTH'>{item.product_name}</th>
                                            <td style={{ verticalAlign: 'middle' }}>
                                                <DateFild
                                                    value={item.completion_date}
                                                    onChange={(date) => setFieldValue(`productCompletions[${index}].completion_date`, date)}
                                                />
                                            </td>
                                            <td style={{ verticalAlign: 'middle' }}>
                                                <textarea
                                                    className="form-control"
                                                    autoComplete='off'
                                                    value={item.notes || ''}
                                                    onChange={(e) => setFieldValue(`productCompletions[${index}].notes`, e.target.value)}
                                                    onBlur={handleBlur}
                                                />
                                            </td>
                                            <td style={{ verticalAlign: 'middle' }}>
                                                <div className='d-flex justify-content-center'>
                                                    <div className="switchs">
                                                        <input
                                                            type="checkbox"
                                                            className="form-control"
                                                            checked={item.is_closed === true}
                                                            onChange={(e) => setFieldValue(`productCompletions[${index}].is_closed`, e.target.checked)}
                                                            onBlur={handleBlur}
                                                        />
                                                        <span className="slider round"></span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                <div className='modalfooters'>
                    <div className='button-boxs grid'>
                        <button onClick={() => handleSubmitActivity()} type='button' className='btn btn-primary'>Save</button>
                        <button onClick={() => setActivityStatus(false)} type='button' className='btn btn-default'>Cancel</button>
                    </div>
                </div>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.projectCategoryId}</span> Project?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    );
}
export default Projects